module.exports = __webpack_public_path__ + "static/media/banner-back.a263df7c.png";